
import React from 'react';
import styles from './HoldingsList.module.css';
import { formatSymbol } from '../utils/symbolFormatter';

const HoldingsList = ({ holdings, title }) => {
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR' }).format(amount);
  };

  return (
    <div className={styles.holdingsList}>
      <h2>{title}</h2>
      {holdings.length > 0 ? (
        <div className={styles.grid}>
          {holdings.map((holding, index) => {
            const pnl = holding.value - holding.investment;
            const pnlPercentage = holding.investment > 0 ? (pnl / holding.investment) * 100 : 0;
            return (
              <div key={index} className={styles.holdingCard}>
                <h3>{formatSymbol(holding.symbol)}</h3>
...
                <div className={styles.row}>
                  <span>Invested:</span>
                  <span>{formatCurrency(holding.investment)}</span>
                </div>
                <div className={styles.row}>
                  <span>Current Value:</span>
                  <span>{formatCurrency(holding.value)}</span>
                </div>
                <div className={styles.row}>
                  <span>Today's P&L:</span>
                  <span className={`${styles.pnl} ${holding.change >= 0 ? styles.positive : styles.negative}`}>
                    {holding.change >= 0 ? '↑' : '↓'} {formatCurrency(holding.change)}
                  </span>
                </div>
                <div className={styles.row}>
                  <span>Total P&L:</span>
                  <span className={`${styles.pnl} ${pnl >= 0 ? styles.positive : styles.negative}`}>
                    {formatCurrency(pnl)} ({pnlPercentage.toFixed(2)}%)
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <div className={styles.empty}>
          <p>No holdings to display.</p>
        </div>
      )}
    </div>
  );
};

export default HoldingsList;
